import React, { useState } from 'react';
import { Button } from './Button';
import { ChevronRightIcon } from 'lucide-react';
import { WaitlistModal } from './WaitlistModal';
export function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="w-full py-16 md:py-24 px-6 md:px-12 flex flex-col items-center text-center" data-id="element-301">
      <div className="inline-flex items-center px-4 py-2 bg-[#F5F7FA] bg-opacity-10 rounded-full mb-8" data-id="element-302">
        <span className="text-sm text-[#F5F7FA]" data-id="element-303">
          Introducing Support for AI Models
        </span>
        <ChevronRightIcon className="h-4 w-4 ml-2 text-[#F5F7FA]" data-id="element-304" />
      </div>
      <h1 className="text-4xl md:text-6xl font-bold mb-6 max-w-4xl" data-id="element-305">
        Prep Smarter. Speak Sharper. Close Faster.
      </h1>
      <p className="text-lg md:text-xl text-[#F5F7FA] text-opacity-80 max-w-2xl mb-10" data-id="element-306">
        Say goodbye to unprepared meetings. Instantly get clear, concise briefs
        of your upcoming calendar events—powered by AI. Whether it's research on
        attendees, business insights, or product fit analysis, we turn
        preparation into clarity.
      </p>
      <div className="flex flex-col sm:flex-row gap-4" data-id="element-307">
        <Button data-id="element-308">Get Started</Button>
        <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-309">
          Sign up to waitlist
        </Button>
      </div>
      <WaitlistModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-310" />
    </section>;
}